module.exports = __webpack_public_path__ + "img/mask-home-banner-en.fc1f9a6a.png";